export { default } from './PostCategories';
export * from './PostCategories.types';
